import { createSlice } from "@reduxjs/toolkit";

export const diagramSlice = createSlice({
  name: "diagram",
  initialState: {
    dateRangeSetting: {},
    filterSetting: {},
  },
  reducers: {
    setDiagramDateRange: (state, action) => {
      if (action.payload) {
        localStorage.setItem(
          "dateRangeSetting",
          JSON.stringify(action.payload)
        );
      } else {
        localStorage.removeItem("dateRangeSetting");
      }

      state.dateRangeSetting = action.payload;
    },
    setDiagramFilter: (state, action) => {
      if (action.payload) {
        localStorage.setItem("filterSetting", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("filterSetting");
      }

      state.filterSetting = action.payload;
    },
  },
});

export const { setDiagramDateRange, setDiagramFilter } = diagramSlice.actions;

export default diagramSlice.reducer;
